import { httpService } from 'core-utilities';
import {
  ChallengeIdAndActionType,
  UserId
} from '../../../react/challenge/twoStepVerification/constants/parameters';
import { Result } from '../../result';
import { toResult } from '../common';
import * as TwoStepVerification from '../types/twoStepVerification';

export const getMetadata = (
  context?: UserId & ChallengeIdAndActionType
): Promise<
  Result<
    TwoStepVerification.GetMetadataReturnType,
    TwoStepVerification.TwoStepVerificationError | null
  >
> =>
  toResult(
    httpService.get(TwoStepVerification.GET_METADATA_CONFIG, context || {}),
    TwoStepVerification.TwoStepVerificationError
  );

export const getUserConfiguration = (
  userId: string,
  challengeParameters?: ChallengeIdAndActionType
): Promise<
  Result<
    TwoStepVerification.GetUserConfigurationReturnType,
    TwoStepVerification.TwoStepVerificationError | null
  >
> =>
  toResult(
    httpService.get(
      TwoStepVerification.GET_USER_CONFIGURATION_CONFIG(userId),
      challengeParameters || {}
    ),
    TwoStepVerification.TwoStepVerificationError
  );

export const sendEmailCode = (
  userId: string,
  challengeParameters: ChallengeIdAndActionType
): Promise<
  Result<
    TwoStepVerification.SendEmailCodeReturnType,
    TwoStepVerification.TwoStepVerificationError | null
  >
> =>
  toResult(
    httpService.post(TwoStepVerification.SEND_EMAIL_CODE_CONFIG(userId), challengeParameters),
    TwoStepVerification.TwoStepVerificationError
  );

export const verifyEmailCode = (
  userId: string,
  verificationParameters: ChallengeIdAndActionType & TwoStepVerification.Code
): Promise<
  Result<
    TwoStepVerification.VerifyEmailCodeReturnType,
    TwoStepVerification.TwoStepVerificationError | null
  >
> =>
  toResult(
    httpService.post(TwoStepVerification.VERIFY_EMAIL_CODE_CONFIG(userId), verificationParameters),
    TwoStepVerification.TwoStepVerificationError
  );

export const verifyAuthenticatorCode = (
  userId: string,
  verificationParameters: ChallengeIdAndActionType & TwoStepVerification.Code
): Promise<
  Result<
    TwoStepVerification.VerifyAuthenticatorCodeReturnType,
    TwoStepVerification.TwoStepVerificationError | null
  >
> =>
  toResult(
    httpService.post(
      TwoStepVerification.VERIFY_AUTHENTICATOR_CODE_CONFIG(userId),
      verificationParameters
    ),
    TwoStepVerification.TwoStepVerificationError
  );

export const verifyRecoveryCode = (
  userId: string,
  verificationParameters: ChallengeIdAndActionType & TwoStepVerification.Code
): Promise<
  Result<
    TwoStepVerification.VerifyRecoveryCodeReturnType,
    TwoStepVerification.TwoStepVerificationError | null
  >
> =>
  toResult(
    httpService.post(
      TwoStepVerification.VERIFY_RECOVERY_CODE_CONFIG(userId),
      verificationParameters
    ),
    TwoStepVerification.TwoStepVerificationError
  );
